export enum AutomaticActionEnum {
    GenerateOrderBySaveBuyerPartAsnwerByClaim = 'GenerateOrderBySaveBuyerPartAsnwerByClaim',
    GenerateOrderBySaveBuyerPartAsnwer = 'GenerateOrderBySaveBuyerPartAsnwer'
}